export default {"src":"/_next/static/media/descriptionMecenat1.e0369998.svg","height":170,"width":340,"blurWidth":0,"blurHeight":0};